// We used this file Instead of using Accessibility.JS Because the theme is not allowing to use accessibility.js file
$(document).ready(function () {
  $('a[href="https://apmmonaco.aftership.com/"]')
    .attr('target', '_blank')
    .attr('rel', 'noopener noreferrer');
  $('a').filter('[target="_blank"]').append('<span class="visually-hidden">Redirecting to a third-party website,opens in a new tab.</span>');

  // Remove role="listbox" from x-listbox elements collection page FIlter
  $('x-listbox[role="listbox"]').removeAttr('role');

});

// Background-video poster alt
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('video img').forEach(img => {
    img.setAttribute('alt', '');
  });
});

// Cart and cart drawer focus management
$(document).ready(function() {
  var lastFocusedElement;
  var drawer = document.querySelector('cart-drawer#cart-drawer');

  // 1. Capture the origin when clicking triggers
  $(document).on('click', 'a[aria-controls="cart-drawer"], buy-buttons button', function() {
    lastFocusedElement = this;
  });

  if (drawer) {
    // 2. Setup the Observer to watch for the "open" attribute
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          
          if (drawer.hasAttribute('open')) {
            // DRAWER OPENED: Focus the heading
            setTimeout(function() {
              var $heading = $('#cart-drawer h2');
              if ($heading.length) {
                $heading.attr('tabindex', '-1').focus();
              }
            }, 50); // Small buffer for DOM rendering
          } else {
            // DRAWER CLOSED: Return focus to the button
            if (lastFocusedElement) {
              lastFocusedElement.focus();
            }
          }
        }
      });
    });

    // Start observing the drawer for attribute changes
    observer.observe(drawer, { attributes: true });
  }
});

// Main menu on click and keydown events
document.addEventListener(
  "keydown",
  function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;

    const summary = e.target.closest("summary.nav-summary");
    if (!summary) return;

    const details = summary.closest("details");
    if (!details) return;

    
    e.preventDefault();
    e.stopImmediatePropagation();

    details.open = !details.open;

    
    summary.setAttribute("aria-expanded", details.open ? "true" : "false");
  },
  true 
);

// // Size chart modal focus management
$(document).ready(function () {
  let lastTrigger = null;

  // 1. Capture the trigger when clicked
  $(document).on("click", ".link--size-chart", function () {
    lastTrigger = this;
    // The modal logic is handled by the Observer below
  });

  // 2. Observer to watch for the modal opening at the end of the body
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check for the modal being added or the 'open' attribute being added
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const modal = document.querySelector('x-modal[open], x-modal.modal--open');
        
        if (modal && modal.style.display !== 'none' && modal.style.opacity !== '0') {
          focusModal(modal);
        }
      }
    });
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['open', 'style', 'class'] 
  });

  function focusModal(modal) {
    // Small delay to allow the 'opacity 1' transition to complete
    setTimeout(() => {
      // Look for close button in Light DOM or Shadow DOM
      let closeBtn = modal.querySelector('button[is="dialog-close-button"], .modal__close-button, [detail="close"]');
      
      if (!closeBtn && modal.shadowRoot) {
        closeBtn = modal.shadowRoot.querySelector('button, .close-button');
      }

      if (closeBtn) {
        closeBtn.focus();
      } else {
        modal.setAttribute('tabindex', '-1');
        modal.focus();
      }
    }, 200);
  }

  // 3. Return focus when the modal is closed
  // Listening for the custom 'close' event usually emitted by <x-modal>
  $(document).on('x-modal:closed modal:close', function () {
    if (lastTrigger) {
      setTimeout(() => {
        lastTrigger.focus();
        lastTrigger = null;
      }, 100);
    }
  });

  // Fallback: If your modal uses a simple attribute toggle for closing
  const closeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (lastTrigger && mutation.target.nodeName === 'X-MODAL' && !mutation.target.hasAttribute('open')) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    });
  });

  closeObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
});

// empty Headings
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').filter(function() {
    return $(this).text().replace(/\s+/g, '') === '' && 
           $(this).children().length === 0;
  }).remove();
});

// Email Label to all Email Address
$(document).ready(function() {
  $('a[href^="mailto:"]').each(function() {
    let email = $(this).attr('href').replace('mailto:', '').trim();
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    if (!existingLabel.includes('Phone Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 

  $('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');
}); 